<template>
    <div>
        <div class="row">
            <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                {{ $t('eventRegistration.summary.event') }}:
            </div>
            <div class="col-auto">
                {{ eventData.shortText }}
            </div>
        </div>
        <div
            v-if="eventData.startDate && eventData.endDate"
            class="row">
            <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                {{ $t('eventRegistration.summary.date') }}:
            </div>
            <div class="col-auto">
                {{ $df($moment(eventData.startDate), 'dateLong') }} - {{ $df($moment(eventData.endDate), 'dateLong') }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                {{ $t('eventRegistration.summary.organizer') }}:
            </div>
            <div class="col-auto">
                <span v-if="eventData.alternativeOrganizer">{{ eventData.alternativeOrganizer }}</span>
                <span v-else>{{ eventData.organizerName }}</span>
            </div>
        </div>
        <div v-if="showOrganizerContactData">
            <div
                v-if="eventData.responsibleEmployeeName"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.responsibleEmployee') }}:
                </div>
                <div class="col-auto">
                    {{ eventData.responsibleEmployeeName }}
                </div>
            </div>
            <div
                v-if="eventData.responsibleEmployeeName && eventData.responsibleEmployeeEmail"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.responsibleEmployeeEmail') }}:
                </div>
                <div class="col-auto">
                    {{ eventData.responsibleEmployeeEmail }}
                </div>
            </div>
            <div
                v-if="eventData.responsibleEmployeeName && eventData.responsibleEmployeePhone"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.responsibleEmployeePhone') }}:
                </div>
                <div class="col-auto">
                    {{ eventData.responsibleEmployeePhone }}
                </div>
            </div>
            <div
                v-if="eventData.responsibleEmployeeName && eventData.responsibleEmployeeContactHours"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.responsibleEmployeeContactHours') }}:
                </div>
                <div class="col-auto">
                    {{ eventData.responsibleEmployeeContactHours }}
                </div>
            </div>
            <!--<div
                v-if="(eventData.organizerName && eventData.organizerEmail) || (eventData.alternativeOrganizer && eventData.alternativeOrganizerEmail)"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.mail') }}:
                </div>
                <div class="col-auto">
                                                    <span v-if="eventData.alternativeOrganizer">
                                                        {{ eventData.alternativeOrganizerEmail }}</span>
                    <span v-else>{{ eventData.organizerEmail }}</span>
                </div>
            </div>
            <div
                v-if="(eventData.organizerName && eventData.organizerPhone) || (eventData.alternativeOrganizer && eventData.alternativeOrganizerPhone)"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.phone') }}:
                </div>
                <div class="col-auto">
                                                    <span v-if="eventData.alternativeOrganizer">
                                                        {{ eventData.alternativeOrganizerPhone }}</span>
                    <span v-else>{{ eventData.organizerPhone }}</span>
                </div>
            </div>-->
        </div>
        <div v-if="showRegistrationState">
            <div
                v-if="registrationData.state"
                class="row">
                <div class="col-md-4 col-lg-3 col-xl-2 font-weight-bold">
                    {{ $t('eventRegistration.summary.state') }}:
                </div>
                <div class="col-auto">
                    {{ $t('eventRegistration.summary.states.' + registrationData.state) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "Basics",
    mixins: [mainRegistrationMixin],
    props: {
        showOrganizerContactData: {
            type: Boolean,
            default: false
        },
        showRegistrationState: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
